import expandIcon from "../../../../assets/images/expand-icon.svg";
import copyIcon from "../../../../assets/images/copy-icon.svg";
import { useEffect, useState } from "react";
import published from "../../../../assets/images/file_check2.svg";
import not_ready_to_publish from "../../../../assets/images/file.svg";
import ready_to_publish from "../../../../assets/images/file_check.svg";
import publishedEdit from "../../../../assets/images/publishedEdit.svg";

export const ExpandScheduleHead = ({
    gridList,
    locationState,
    backToLinear
}) => {
    const [dayData, setDayData] = useState()
    useEffect(() => {
        const todayData = gridList?.find(item => item.date === locationState?.state?.panelDate);
        setDayData(todayData)
    })
    return (
        <div className="d-flex justify-content-between">
            <span className="text-white">
                <span style={{ fontSize: "16px", color: "#999999" }}>
                    {new Date(gridList?.find(item => item.date === locationState?.state?.panelDate)?.date).toLocaleDateString("en-US", { weekday: "short" })}
                </span>
                {" "}
                <span style={{ fontSize: "20px"}}>
                    {new Date(gridList?.find(item => item.date === locationState?.state?.panelDate)?.date).toLocaleDateString("en-US", {
                    month: "short",
                    day: "2-digit",
                    })}
                </span>
            </span>
            <div className="d-flex justify-content-between">
            <a className="btn-circle mx-1" style={{borderRadius: "3px"}}>
                {
                    dayData?.published?
                        dayData?.isEdit?
                            <a className="btn-circle" style={{borderRadius: "3px", background: "#ff6464"}} >
                                <img src={publishedEdit} width= {15}/>
                            </a>
                        :
                            <a className="btn-circle" style={{borderRadius: "3px", background: "#73DF5C"}} >
                                <img src={published} width= {15}/>
                            </a>
                        
                    :
                        (dayData?.scheduleItems?.reduce((total, data) => total + (data?.totalDuration || 0), 0)) >= 86400000 ?
                            // <a className="btn mx-1 p-1" style={{height: '28px', background: "#FB923C"}} onClick={() => confirmPublishWithDate(item?.date)}>
                            //     <img src={ready_to_publish} width= {20}/>
                            // </a>
                            <a className="btn-circle" style={{borderRadius: "3px", background: "#FB923C"}}>
                                <img src={ready_to_publish} width= {15}/>
                            </a>
                        :
                            <a className="btn-circle" style={{borderRadius: "3px"}} >
                                <img src={not_ready_to_publish} width= {15}/>
                            </a>
                }
            </a>
                <a className="btn-circle ms-1" style={{borderRadius: "3px"}} onClick={(e)=> {backToLinear(e)}}>
                    <img src={expandIcon} width= {15}/>
                </a>
            </div>
        </div>
    )
}